import { capitalize } from "lodash";
import K from "./constants";

const { DEVELOPMENT, QA, STAGING } = K.Environment;

export const isNonProdEnv = () => [DEVELOPMENT, QA, STAGING].includes(K.Server);

export const getEnvName = () => {
  return K.Server === QA ? K.Server.toUpperCase() : capitalize(K.Server);
};
